import React, { useState } from 'react';

import { SupervisionUserEventsFilter } from 'components/Supervision/SupervisionHeader/types';
import SupervisionTable from 'components/Supervision/SupervisionTable/SupervisionTable';
import { SortOptions } from 'components/Supervision/SupervisionTable/useSearchUserEventsDto';
import SupervisionUserEventsFilterProvider from 'components/Supervision/useSupervisionUserEventsFilterContext';
import { TableSort } from 'components/WrappedComponents/Table/types';
import SortProvider from 'hooks/SortStoreContext';

const PageSupervision = () => {
  const [filter, setFilter] = useState<Partial<SupervisionUserEventsFilter>>(
    {},
  );
  const [sort, setSort] = useState<Partial<TableSort<SortOptions>>>({
    DATE_REALISATION: false,
  });
  return (
    <SupervisionUserEventsFilterProvider
      value={{
        filter: filter,
        setFilter: setFilter,
      }}
    >
      <SortProvider value={{ sort: sort, setSort: setSort }}>
        <SupervisionTable />
      </SortProvider>
    </SupervisionUserEventsFilterProvider>
  );
};

export default PageSupervision;
